import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import FieldRow from '../../../../F22/common/FieldRow';
import { calcularLiquidacion } from '../liquidacion';

/**
 * Liquidación única del F22 AT 2026 del empresario individual (14 D N°3): el IGC de la
 * persona y el IDPC de su empresa en un solo resultado (código 305), menos los PPM, la mayor
 * retención y los remanentes devolvibles. Ver liquidacion.js.
 */
const LiquidacionSection = ({ data }) => {
  const c = calcularLiquidacion(data);
  return (
    <SectionContainer title="Liquidación del F22" subtitle="Empresa y persona en un solo resultado">
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Impuestos</h4>
        <FieldRow label="Línea 53 · IGC de la persona" code="31" sign="(+)" value={c[31]} computed />
        <FieldRow label="Línea 54 · Base imponible del IDPC (código 1440)" code="18" value={c[18]} computed />
        <FieldRow label="Línea 54 · Rebajas al impuesto" code="19" value={c[19]} computed />
        <FieldRow label="Línea 54 · IDPC de la empresa (régimen Pro Pyme, 14 D N°3)" code="20" sign="(+)" value={c[20]} computed />
        {c.exentoIDPC && (
          <p className="f22-hint">
            Exento del IDPC: la renta líquida no supera 1 UTA de diciembre de 2025 ($834.504), art. 40 N° 6 LIR.
          </p>
        )}
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Deducciones</h4>
        <FieldRow label="Línea 85 · PPM" code="36" sign="(-)" value={c[36]} computed />
        <FieldRow label="Línea 92 · Mayor retención de impuesto único solicitada" code="54" sign="(-)" value={c[54]} computed />
        <FieldRow label="Línea 97 · Remanente de crédito del impuesto único" code="119" value={c[119]} computed />
        <FieldRow label="Línea 97 · Remanente de crédito por IDPC" code="116" value={c[116]} computed />
        <FieldRow label="Línea 97 · Total remanentes" code="757" sign="(-)" value={c[757]} computed />
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Resultado de la renta de la empresa</h4>
        <FieldRow label="IDPC de la empresa (20) menos PPM (36)" sign="(=)" value={c.resultadoEmpresa} computed className="f22-field-total" />
        <p className="f22-hint">
          Es lo que la empresa debe pagar (positivo) o su excedente de PPM (negativo). Solo este resultado entra a los
          asientos contables de la empresa; el resultado del F22 de abajo también incluye la renta de la persona.
        </p>
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Resultado del F22 (empresa + persona)</h4>
        <FieldRow label="Línea 109 · RESULTADO LIQUIDACIÓN ANUAL IMPUESTO A LA RENTA" code="305" sign="(=)" value={c[305]} computed className="f22-field-final-result" />
        <FieldRow label="Línea 110 · Saldo a favor" code="85" value={c[85]} computed />
        <FieldRow label="Línea 112 · Devolución solicitada" code="87" value={c[87]} computed />
        <FieldRow label="Línea 113 · Impuesto adeudado" code="90" value={c[90]} computed />
        <p className="f22-hint">
          Positivo = impuesto a pagar · Negativo = saldo a favor. El empresario individual no usa el código 86, así
          que la devolución es igual al saldo a favor. No incluye el reajuste del art. 72 LIR, que el SII publica en abril.
        </p>
      </div>
    </SectionContainer>
  );
};

export default LiquidacionSection;
